export default {
  offer: "Offerte",
  draft: "Concept",
  readyToSend: "Klaar om te versturen",
  sent: "Verstuurd",
  overdue: "Te laat",
  paid: "Betaald",
  reminded: "Herinnering verstuurd",
  irrecoverable: "Oninbaar",
  credited: "Gecrediteerd",
}
